<template>
  <div class="cert-home">
    <!-- 背景图案 -->
    <div class="background-pattern"></div>

    <!-- 标题部分 -->
    <div class="title-section">
      <div class="title">培训证书查询</div>
      <div class="subtitle">Data Center</div>
    </div>

    <!-- 提示文字 -->
    <div class="hint-text">设计制作，证书查询</div>

    <!-- 功能卡片 -->
    <div class="card-container">
      <div class="card" @click="toPage('/certList')">
        <van-icon name="points" color="#1989fa" />
        <div class="card-title">123</div>
      </div>
      <div class="card" @click="toPage('/cert')">
        <van-icon name="idcard" color="#1989fa" />
        <div class="card-title">证书</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    toPage(url) {
      this.$router.push(url);
    },
  },
};
</script>

<style>
/* 背景图案 */
.background-pattern {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 75px;
  background: linear-gradient(90deg, #0091ff, #64b5f6, #b3e5fc);
  opacity: 0.3;
  z-index: -1;
}

/* 标题部分 */
.title-section {
  text-align: center;
  margin-top: 15px;
}

.title {
  font-size: 13px;
  font-weight: bold;
  color: #333;
}

.subtitle {
  font-size: 14px;
  font-weight: bold;
  color: #0091ff;
  margin-top: 10px;
}

/* 提示文字 */
.hint-text {
  text-align: center;
  color: #999;
  margin: 10px 0;
  font-size: 14px;
}

/* 卡片容器 */
.card-container {
  display: flex;
  justify-content: center;
  gap: 10px;
  margin: 10px 0;
}

.card {
  width: 150px;
  height: 75px;
  background-color: #e0e0e0;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 32px;
}

.card-title {
  font-size: 14px;
  color: #333;
}
</style>